import * as React from 'react';
import { Tag } from '../../../components/Tag';
import { UIHelper } from '../../UIHelper';
import { SummaryText, useOnePageAdaptableWizardContext } from '../../Wizard/OnePageAdaptableWizard';
export const ScheduleScheduleSummary = () => {
    const { data } = useOnePageAdaptableWizardContext();
    return (React.createElement(SummaryText, null,
        "Schedule: ",
        React.createElement(Tag, null, UIHelper.getScheduleDescription(data.Schedule))));
};
